var _defs, _path, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductsGiftTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.125 22.986a.861.861 0 0 0 1.217 0L23 20.33a.861.861 0 0 0 0-1.217l-3.875-3.873a.863.863 0 0 0-.609-.252h-2.655a.86.86 0 0 0-.861.861v2.656a.861.861 0 0 0 .252.608ZM15.168 15.339l-1.851-1.851M12 17.238H3a.75.75 0 0 1-.75-.75v-6.75M15.75 9.738v2.25"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 0.75,
    y: 5.988,
    width: 16.5,
    height: 3.75,
    rx: 0.75,
    ry: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9 17.238V5.988M4.734 3.867a11.863 11.863 0 0 0 4.242 2.121 11.837 11.837 0 0 0-2.121-4.242C5.537.428 4.79.63 4.2 1.216s-.784 1.333.534 2.651ZM13.266 3.867a11.864 11.864 0 0 1-4.243 2.121 11.855 11.855 0 0 1 2.121-4.242C12.463.428 13.21.63 13.8 1.216s.784 1.333-.534 2.651Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductsGiftTag);
export default __webpack_public_path__ + "static/media/products-gift-tag.a27a435beb45bbbb436e0fab5553d787.svg";
export { ForwardRef as ReactComponent };